<template>
  <Popper
    :trigger="trigger"
    :disabled="disabled"
    :delayOnMouseOver="delay"
    :options="{
      placement: 'top',
    }">
    <div
      class="popper bg-whiteOverride border-whiteOverride p-base shadow-popper break-all"
      data-test="popper-content"
    >
      <slot name="popper-content" />
    </div>
    <slot
      slot="reference"
      name="reference"
    />
  </Popper>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  components: {
    Popper,
  },
  props: {
    trigger: {
      type: String,
      required: true,
      validator(value) {
        return ['hover', 'focus', 'clickToOpen', 'clickToToggle'].includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 10,
    },
  },
};
</script>
